module.exports = __webpack_public_path__ + "img/ics_o_info_circle.823ed772.svg";